export function sanitizeRefreshMeta(node: HTMLElement, data): HTMLElement {
  if (data.attrName === 'http-equiv' && data.attrValue === 'refresh' && node.tagName === 'META') {
    node.remove();
  }
  return node;
}
